import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postMasterType, postMasterTypeSave, postMasterTypeStatus, deleteMasterType } from '../../apiservices/ApiServices';

const Master = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [data, setData] = useState([]);

    const postMasterTypes = async (postData) => {
        setLoading(true);
        try {
            const res = await postMasterType(postData);
            setData(res.data.data.records);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateMaster = async () => {
        let postData = {
            search: "",
            filters: {
                name: ""
            },
            page: 1,
            length: 100
        }
        try {
            const res = await postMasterType(postData);
            setData(res.data.data.records);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            search: "",
            filters: {
                name: ""
            },
            page: 1,
            length: 100
        }
        postMasterTypes(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Masters Name",
                accessor: "name",
                width: 400,
            },
            {
                Header: "Masters Sub",
                accessor: "data_count",
            },
            {
                Header: "is Active",
                accessor: "isactive",
                width: 99,
                disableSortBy: true,
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ], []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const initialValues = {
        id: '',
        name: '',
        isActive: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            let postData;

            if (isEdit) {
                postData = {
                    id: values.id,
                    name: values.name,
                    is_active: values.isActive,
                }
            }
            else {
                postData = {
                    name: values.name,
                    is_active: values.isActive,
                }
            }

            try {
                const res = await postMasterTypeSave(postData);
                toast.success(res.data.message);
                postUpdateMaster();
                setAddModal(false);
                setIsEdit(false);
                setLoadings(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        formik.resetForm();
        console.log(rowData);
        setFieldValue('id', rowData?.id);
        setFieldValue('name', rowData?.name);
        setFieldValue('isActive', rowData?.is_active);

        setAddModal(true);
        setIsEdit(true);
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.id);
        setFieldValue('name', rowData?.name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteMasterType(values.id);
            toast.success(res.data.message);
            postUpdateMaster();
            setShow(false);
            setFieldValue('id', '');
            setFieldValue('name', '');
            setLoadings(false);

        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleIsActive = async (rowData) => {
        setLoadings(true);
        let postData = {
            id: rowData?.id
        }
        try {
            const res = await postMasterTypeStatus(postData);
            toast.success(res.data.message);
            postUpdateMaster();
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Masters" active="Masters" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body id='mainMaster' className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Masters</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button variant="primary" onClick={() => { setAddModal(true); setFieldValue('isActive', 1) }}>Add New</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                        onIsActive={handleIsActive}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New Master"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={9}>
                            <div className="form-group">
                                <label className="form-label">Master Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">Is Active</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            id='isActive'
                                            name='isActive'
                                            className="form-control"
                                            autoComplete='off'
                                            checked={values.isActive === 1}
                                            onChange={(e) => {
                                                setFieldValue(
                                                    'isActive',
                                                    e.target.checked ? 1 : 0
                                                );
                                            }}
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.name}</span> Masters?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default Master
